"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentTimetableRules = getCurrentTimetableRules;
var formatStartAndEndTime_1 = require("./formatStartAndEndTime");
function getCurrentTimetableRules(timezonedDate, timetable) {
    var currentTimetableRules = [];
    var weekDay = timezonedDate.isoWeekday();
    for (var _i = 0, timetable_1 = timetable; _i < timetable_1.length; _i++) {
        var rule = timetable_1[_i];
        if (rule.days.findIndex(function (day) { return weekDay === day; }) < 0) {
            continue;
        }
        var _a = (0, formatStartAndEndTime_1.formatStartAndEndTime)(timezonedDate, rule), startTime = _a.startTime, endTime = _a.endTime;
        if (!timezonedDate.isSameOrAfter(startTime) || !timezonedDate.isBefore(endTime)) {
            continue;
        }
        currentTimetableRules.push(rule);
    }
    return currentTimetableRules;
}
//# sourceMappingURL=getCurrentTimetableRules.js.map